// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { Classes, MPDIcon } from "src/mpd-library";

import "./styles.css";

export interface IMultiMediaDropActiveProps extends HTMLDivProps {
  multiMedia: any;
}

export const MultiMediaDropActive: React.SFC<
  IMultiMediaDropActiveProps
> = props => {
  const { multiMedia } = props;

  const { uploadPercentage, fileName } = multiMedia;

  const classes = classNames(
    "multimedia-drop-active",
    fileName !== null && Classes.ACTIVE
  );

  return (
    <div className={classes}>
      <div className="dropzone-content">
        <MPDIcon name="file-name" />
        <Text className="file-name"> {fileName} </Text>
        <Text className="upload-percentage">
          Uploading {uploadPercentage} %
        </Text>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia-drop-active.tsx